import ContainerHeader from 'Components/Atoms/Containers/ContainerHeader/ContainerHeader';
import Paper from 'Components/Atoms/Containers/Paper/Paper';
import EditButtons from 'Components/Atoms/EditButtons/EditButtons';
import RowItem from 'Components/Atoms/Row/RowItem';
import RowItemInfo from 'Components/Atoms/Row/RowItemInfo';
import RowItemTitle from 'Components/Atoms/Row/RowItemTitle';
import Field from 'Pages/Dashboard/Settings/FieldsManagement/Fields/FieldTypes/Field';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ModuleHelper, { FILE_GENERATOR_TEMPLATES, getFileGeneratorTemplateDisplayValue, getModules, MODULES } from 'Services/Settings/Modules/Helper';
import { FieldType } from 'Store/FieldManagement/PropTypes';
import { StoreState } from 'Store/Reducers';
import { fetchEntities, patchEntity } from 'Store/Settings/Entities/Actions';
import { EntityId } from 'Store/Settings/Entities/PropTypes';
import { getEntitiesById } from 'Store/Settings/Entities/Selectors';
import styles from './EntityModulesSettings.module.sass';

const EntityModulesSettings = ({id, entityById, ...props}: EntityModulesSettingsProps) => {
    const [state, setState] = useState({
        isEdit: false
    });

    const [data, setData] = useState({
        unsaved: {},
        saved: entityById[id]?.modules || {}
    });

    const getData = () => ({...data.saved, ...data.unsaved});
    const handleCancel = () => setData({...data, unsaved: {}});
    const handleSave = () => props.patchEntity(id, { modules: getData() });

    return <>
        <ContainerHeader title={'Modules'}>
            <EditButtons
                onEdit={(value) => setState({...state, isEdit: value})}
                onSave={handleSave}
                onCancel={handleCancel}
            />
        </ContainerHeader>
        <Paper>
            {
                getModules().map((item: any) => {
                    return <RowItem wrap>
                        <RowItemTitle>{ModuleHelper.getModuleDisplayValue(item)}</RowItemTitle>
                        <RowItemInfo>
                            <Field
                                isEdit={state.isEdit}
                                type={FieldType.Toggle}
                                value={!!getData()[item]}
                                onChange={(value) => setData({
                                    ...data,
                                    unsaved: {
                                        ...data.unsaved,
                                        [item]: value
                                    }
                                })}
                            />
                        </RowItemInfo>
                        {
                            item == MODULES.FILE_GENERATOR &&
                            !!getData()[item] &&
                            Object.values(FILE_GENERATOR_TEMPLATES).map((template: any) => {
                                return <>
                                    <RowItemTitle><div className={styles['connector']} />{getFileGeneratorTemplateDisplayValue(template)}</RowItemTitle>
                                    <RowItemInfo>
                                        <Field
                                            isEdit={state.isEdit}
                                            type={FieldType.Toggle}
                                            value={!!getData()[item][template]}
                                            onChange={(value) => setData({
                                                    ...data,
                                                    unsaved: {
                                                        ...data.unsaved,
                                                        [item]: {
                                                            ...data.saved[item],
                                                            ...data.unsaved[item],
                                                            [template]: value
                                                        }
                                                    }
                                                })
                                            }
                                        />
                                    </RowItemInfo>
                                </>
                            })
                        }
                    </RowItem>;
                })
            }
        </Paper>
    </>
}

interface Props {
    id: EntityId
};

const mapState = (state: StoreState) => ({
    entityById: getEntitiesById(state)
});

const mapDispatch = {
    patchEntity,
    fetchEntities
};

type EntityModulesSettingsProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(EntityModulesSettings);